import { AddAssigneeNotification, RemoveAssigneeNotification } from '../../commonTypes/NotificationTypes/project.types';
import { TranslationFormatter } from './TranslationFormatter';

export class NotificationProjectService {
    private formatter: TranslationFormatter;

    constructor(formatter: TranslationFormatter) {
        this.formatter = formatter;
    }

    public generateAddAssigneeMessage(notification: AddAssigneeNotification): string {
        const { projectName, clientName } = notification.message;
        return this.formatter.getTranslation('notificationMessages.addAssignee', {
            projectName,
            clientName,
        });
    }

    public generateRemoveAssigneeMessage(notification: RemoveAssigneeNotification): string {
        const { projectName } = notification.message;
        return this.formatter.getTranslation('notificationMessages.removeAssignee', {
            projectName,
        });
    }
}
